import React, { useState } from "react";
import { View, Text, Platform, TouchableOpacity, Dimensions } from 'react-native';
import TypographyDLSBase from "../../typography/TypographyDLS.base";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, ImageSizeTokens } from "@voltmoney/schema";
import Typography from "../../typography/Typography";
import Icon from "../../icon/Icon";
import Divider from "../../divider/Divider";
import Stepper from "../../stepper/Stepper";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import BottomSheet from "../BottomSheet";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { isMobile, isMobileView } from "../../stack/utils";
import { addCommasToNumber, getScreenType } from "../utils";
import Space from "../../space/Space";
import Image from "../../image/Image";
import BoilerPlate from "../boilerPlate/BoilerPlate";
const RequestWithdraw = ({ height, triggerAction, loading, stepperData, doneAction, res, accountNumber, bankName, bankCode, isFirstJourney, navigateToTransaction, verifyOTPResponse }) => {
    const withdrawlValue = verifyOTPResponse?.amount;
    const accountFee = res?.disbursalAdditionalDetails?.accountOpeningFee;
    const netDisbursalAmount = res?.disbursalAdditionalDetails?.netDisbursalAmount;
    const processingFee = res?.disbursalAdditionalDetails?.processingFee;
    const GST = res?.disbursalAdditionalDetails?.gstOnProcessingFee;
    const stampDutyFee = res?.disbursalAdditionalDetails?.stampDutyFee;
    const processedMessage = verifyOTPResponse?.remark;
    const lienMarkingFee = res?.disbursalAdditionalDetails?.lienMarkingFee;
    const bankAccountDetails = `${bankName} xxxx ${accountNumber?.slice(accountNumber.length - 4)}`;
    const [showModal, setShowModal] = useState(false);
    const calModalHeight = () => {
        let height = 0;
        if (isFirstJourney) {
            if (lienMarkingFee === null || lienMarkingFee === undefined) {
                if (isMobileView()) {
                    height = 356;
                }
                else {
                    height = 338;
                }
            }
            else {
                if (isMobileView()) {
                    height = 390;
                }
                else {
                    height = 364;
                }
            }
        }
        else {
            if (isMobileView()) {
                height = 278;
            }
            else {
                height = 242;
            }
        }
        return height;
    };
    const [modalHeight, setModalHeight] = useState(calModalHeight());
    const renderAccountFeeModal = () => {
        return (React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1 }, activeOpacity: 1 },
            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: "Account opening fee" }),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, { style: { padding: 8, backgroundColor: '#F1F3F5', borderRadius: 6 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: "This is a one-time fee. It won't apply on any future withdrawals.", textAlign: TextAlignTokens.left })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Processing fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(Number(processingFee))}` })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "18% GST on processing fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(Number(GST))}` })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Stamp duty fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(Number(stampDutyFee))}` })),
            (lienMarkingFee !== null && lienMarkingFee !== undefined) && React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Lien marking" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `₹${addCommasToNumber(lienMarkingFee)}` })),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "Account opening fee" }),
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: `₹${addCommasToNumber(Number(accountFee))}` })),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: loading, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: () => setShowModal(false), isDisabled: false })));
    };
    const renderOutstandingChargesModal = () => {
        return (React.createElement(TouchableOpacity, { style: { paddingHorizontal: 16, paddingBottom: 16, paddingTop: 24, zIndex: 1 }, activeOpacity: 1 },
            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.H4S, label: "Outstanding charges" }),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: { padding: 12, backgroundColor: '#F1F3F5', borderRadius: 8 } },
                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: `There are outstanding charges of Rs. ${accountFee} on your loan account.`, color: ColorTokens.Grey_Charcoal }),
                React.createElement(Text, { style: { marginTop: 16 } },
                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Details of charges are available in account statement. To view details, ", color: ColorTokens.Grey_Charcoal }),
                    (Platform.OS === 'ios' || Platform.OS === 'android') && React.createElement(Text, { onPress: () => {
                            if (navigateToTransaction)
                                triggerAction(navigateToTransaction);
                        }, style: { fontFamily: 'Inter-SemiBold', fontSize: 14, fontWeight: '600', color: '#1434CB', lineHeight: 20 } }, "click here."),
                    (Platform.OS === 'web') && React.createElement(TouchableOpacity, { style: {}, onPress: () => {
                            if (navigateToTransaction)
                                triggerAction(navigateToTransaction);
                        } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1S, label: "click here.", color: ColorTokens.Primary_100 })))),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: loading, typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", onPress: () => setShowModal(false), isDisabled: false })));
    };
    const modalContentPresenter = () => {
        if (showModal) {
            if (isFirstJourney)
                return renderAccountFeeModal();
            else
                return renderOutstandingChargesModal();
        }
    };
    const footer = () => {
        return (React.createElement(View, { style: {
                width: '100%'
            } },
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk, height: 1 }),
            React.createElement(View, { style: { padding: 16 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: loading, typeDLS: ButtonTypeDLS.PRIMARY, label: "Done", onPress: () => {
                        triggerAction({
                            ...doneAction
                        });
                    }, isDisabled: false }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BoilerPlate, { height: height, bottomChildren: React.createElement(React.Fragment, null, footer()) },
            React.createElement(View, { style: { marginTop: Platform.OS === 'ios' ? 52 : 36, paddingHorizontal: 16, paddingBottom: 16 } },
                React.createElement(View, { style: {
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        borderWidth: 1,
                        borderColor: "#E4E7EC",
                        padding: 16
                    } },
                    React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: "Withdrawal request received " }),
                    React.createElement(View, { style: { marginTop: 4 } },
                        React.createElement(Typography, { label: `₹${addCommasToNumber(withdrawlValue)}`, fontSize: FontSizeTokens.XXXXL, lineHeight: 40, fontWeight: "700", color: ColorTokens.Grey_Night })),
                    accountFee > 0 && React.createElement(View, { style: { marginTop: 16, backgroundColor: "#F9FAFB", borderRadius: 8, padding: 12 } },
                        React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between' } },
                            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                                React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B1R, label: isFirstJourney ? "Account opening fee(incl. GST)" : "Outstanding charges" }),
                                React.createElement(TouchableOpacity, { style: { marginLeft: 4 }, hitSlop: { top: 16, left: 16, right: 16, bottom: 16 }, onPress: () => { setShowModal(true); } },
                                    React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.MD, color: ColorTokens.Grey_Night }))),
                            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: `₹${addCommasToNumber(accountFee)}` })),
                        React.createElement(View, { style: { marginVertical: 12 } },
                            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            } },
                            React.createElement(Typography, { label: "Net disbursal amount", typeDLS: TypographyTypeDLS.B2R }),
                            React.createElement(Typography, { label: `₹${addCommasToNumber(netDisbursalAmount)}`, typeDLS: TypographyTypeDLS.B2B, color: ColorTokens.Secondary_100 })))),
                React.createElement(View, { style: {
                        borderBottomLeftRadius: 12,
                        borderBottomRightRadius: 12,
                        borderWidth: 1,
                        borderColor: "#E4E7EC",
                        paddingTop: 24,
                        paddingHorizontal: 16,
                        paddingBottom: 16
                    } },
                    React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData, isProcessing: true }),
                    (processedMessage != '' && processedMessage !== undefined && processedMessage !== null) && React.createElement(View, { style: { padding: 10, backgroundColor: '#FDF7E7', borderRadius: 6 } },
                        React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2M, label: processedMessage })),
                    processedMessage && React.createElement(View, { style: { marginVertical: 16 } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    (processedMessage === '' || processedMessage === null || processedMessage === undefined) && React.createElement(View, { style: { marginBottom: 16 } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                    React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                        React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode}.png`, defaultUri: "https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png", size: ImageSizeTokens.XS }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(TypographyDLSBase, { typeDLS: TypographyTypeDLS.B2R, label: `To ${bankAccountDetails}` })))))),
        showModal &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    zIndex: 99
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))));
};
export default RequestWithdraw;
